import React from "react";
import styles from './index.module.css';

const Footer = () => {
    return (
      <footer className={styles.footer}>
           <div>
            MHoldings : Design & Developed by 
            <a
              className={styles.ardillaLink}
              href="https://www.ardillalabs.com/"
              rel="noopener noreferrer"
              target="_blank"
            >
             Ardillalabs
            </a>
          </div>
      </footer>
    );
  };
  
  export default Footer;